import { AxiosError } from "axios";

import { api } from "./base";
import type { IDashboard } from "@/types";

export type TDashboardParams = {
   start?: string;
   end?: string;
};

export class DashboardService {
   public async getDashboard(slug: string, params?: TDashboardParams) {
      try {
         const response = await api.get<IDashboard>(
            `/workspaces/${slug}/dashboard`,
            {
               params,
            },
         );
         return response.data;
      } catch (error) {
         if (error instanceof AxiosError) {
            throw error.response?.data;
         }
         throw error;
      }
   }
}
